import { render, staticRenderFns } from "./CategoryCardAttributesEntry.vue?vue&type=template&id=0201faa0&scoped=true"
import script from "./CategoryCardAttributesEntry.vue?vue&type=script&lang=ts"
export * from "./CategoryCardAttributesEntry.vue?vue&type=script&lang=ts"
import style0 from "./CategoryCardAttributesEntry.vue?vue&type=style&index=0&id=0201faa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0201faa0",
  null
  
)

export default component.exports